import React from "react";

const SvgCheck = props => <svg fill="none" viewBox="0 0 24 24" width={24} height={24} {...props}><defs /><path stroke="#1A1A1A" d="M20 6L9 17l-5-5" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KICA8ZGVmcy8+CiAgPHBhdGggc3Ryb2tlPSIjMUExQTFBIiBkPSJNMjAgNkw5IDE3bC01LTUiLz4KPC9zdmc+Cgo=";
export { SvgCheck as ReactComponent };